import React, { FC, useState } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { getFirstLine, findLastUserPromptIndex } from './utils';
import { FormatMessage } from './FormatMessage';

interface ConversationData {
    messages: any[];
}

const ConversationMessages: FC<{ conversationData: ConversationData }> = ({ conversationData }) => {
    const { messages } = conversationData;
    const [expanded, setExpanded] = useState<number | false>(false);
    let relevantMessages = messages;

    const lastUserPromptIndex = findLastUserPromptIndex(relevantMessages);
    if (lastUserPromptIndex !== -1) {
        relevantMessages = relevantMessages.slice(lastUserPromptIndex);
    }

    return (
        <Box>
            {relevantMessages.map((msg, idx) => (
                <Accordion
                    key={idx}
                    expanded={expanded === idx}
                    onChange={(_, isExpanded) => setExpanded(isExpanded ? idx : false)}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle2" sx={{ flex: 1 }}>
                            <b>
                                {' '}
                                {msg.kind === 'request'
                                    ? 'Llm trigger'
                                    : msg.kind === 'response'
                                      ? 'Llm response'
                                      : msg.kind}
                            </b>
                            {msg.timestamp && (
                                <>
                                    {' '}
                                    <b>at</b> {msg.timestamp}
                                </>
                            )}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                ml: 2,
                                flex: 2,
                                minWidth: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {getFirstLine(msg)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormatMessage msg={msg} />
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default ConversationMessages;
